import { sentenceCase } from 'change-case';

export function fLogType(logType) {
  switch (logType) {
    case 'unlock_chapa_success':
      return sentenceCase('Apertura');
    case 'unlock_chapa_error':
      return sentenceCase('Error');
    case 'chapa_create_or_edit_access':
      return sentenceCase('Chapa creada o editada');
    case 'chapa_removed_access':
      return sentenceCase('Acceso eliminado');
    default:
      return 'No definido';
  }
}

export function fUserRole(logType) {
  switch (logType) {
    case 'guest':
      return sentenceCase('invitado');
    case 'owner':
      return 'Dueño';
    case 'custodian':
      return sentenceCase('conserje');
    case 'admin':
      return sentenceCase('administrador');
    case 'super admin':
      return sentenceCase('super admin');
    default:
      return 'No definido';
  }
}
